/* Endurrad — pagina dei risultati di ricerca nello stile della bacheca. File aggiunto: sopravvive agli aggiornamenti del tema.
   Caricato da sections/erd-ricerca.liquid.
   - Fascia «Solo accessori per la tua moto»: legge la moto scelta (localStorage «erd_moto_sel», la stessa della barra in alto)
     e attiva i filtri Shopify Marca moto + Modello moto (filtri lato server, nessun filtro fatto nel browser).
   - Categorie, ordinamento e interruttore aggiornano i risultati senza ricaricare la pagina, con il sistema filtri del tema.
   - Contatore «X di Y risultati visti» e bollino «Ok per la tua moto» (dicitura fissa scelta da Giuseppe).
   - Ricerca intelligente: la pagina si apre con q=* più i filtri; titolo e barra mostrano la parola scritta dal cliente (erd_q). */
(function () {
  var P_MARCA = 'filter.p.m.filtro.marca_moto';
  var P_MOD = 'filter.p.m.filtro.modello_moto';

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function norm(s) { return String(s || '').trim().toLowerCase().replace(/\s+/g, ' '); }
  function moto() {
    try { return JSON.parse(window.localStorage.getItem('erd_moto_sel') || 'null'); } catch (e) { return null; }
  }
  function form() {
    return $('#FacetFiltersContainer form[is="facet-form"]') || $('form[is="facet-form"]');
  }

  /* Parola cercata dal cliente: q, oppure erd_q quando la ricerca intelligente ha messo q=* e i filtri */
  function parolaCercata() {
    var p = new URLSearchParams(window.location.search);
    var q = (p.get('q') || '').trim();
    if (q && q !== '*') return q;
    var filtri = false;
    p.forEach(function (v, k) { if (k.indexOf('filter.') === 0) filtri = true; });
    var o = (p.get('erd_q') || '').trim();
    if (o && filtri) return o;
    var tipi = p.getAll('filter.p.product_type');
    if (tipi.length) return tipi.join(', ');
    return '';
  }

  /* Titolo «Accessori per «*»» → «Accessori per «specchietti»» */
  function titolo() {
    var h = $('.erd-ric__h1');
    var em = h && $('em', h);
    if (!em || em.textContent.trim() !== '*') return;
    var w = parolaCercata();
    if (w) em.textContent = w;
    else h.textContent = 'Tutti gli accessori Endurrad';
    if (w) document.title = 'Accessori per «' + w + '» – Endurrad';
  }

  /* Aggiorna i risultati: con il sistema filtri del tema se c'è, altrimenti ricaricando la pagina */
  function vai(href) {
    var u = new URL(href, window.location.origin);
    u.searchParams.delete('page');
    u.searchParams.delete('section_id');
    var f = form();
    if (f && typeof f.renderSection === 'function' && window.theme && theme.utils && theme.utils.sectionId) {
      try { history.replaceState({}, '', u.pathname + u.search); } catch (e) {}
      u.searchParams.set('section_id', theme.utils.sectionId(f));
      f.renderSection(u.toString());
    } else {
      window.location.href = u.pathname + u.search;
    }
  }

  var filtroMotoAttivo = false;
  /* Scheda «ok» per la moto: filtro moto attivo, prodotto universale (filtro.universale) o modello in filtro.modello_moto */
  function okScheda(c, base) {
    if (c.classList.contains('article-card')) return false;
    if (filtroMotoAttivo) return true;
    if (!base) return false;
    if (c.hasAttribute('data-erd-universale')) return true;
    return (c.getAttribute('data-erd-modelli') || '').split('|').some(function (x) { return norm(x) === base; });
  }
  function schede() { return $$('#ProductGridContainer motion-list > .card'); }
  function totale() { var c = $('.erd-ric__cnt'); return c ? parseInt(c.textContent, 10) || 0 : 0; }

  function compat() {
    var box = $('[data-erd-ric-compat]');
    var cnt = $('[data-erd-ric-cnt-moto]');
    filtroMotoAttivo = false;
    if (!box) return;
    var d;
    try { d = JSON.parse($('[data-erd-ric-dati]', box).textContent); } catch (e) { return; }
    var sw = $('[data-erd-ric-sw]', box), sc = $('[data-erd-ric-scegli]', box);
    var n = $('[data-erd-ric-n]', box), t = $('[data-erd-ric-titolo]', box), so = $('[data-erd-ric-sotto]', box);
    var m = moto();
    var attivi = (d.modelli || []).filter(function (x) { return x.on; });
    var u = new URL(window.location.href);
    u.searchParams.delete('section_id');
    u.searchParams.delete('page');

    function spento() {
      var x = new URL(u);
      x.searchParams.delete(P_MOD);
      x.searchParams.delete(P_MARCA);
      return x.pathname + x.search;
    }
    function stato(on) {
      sw.hidden = false;
      sc.hidden = true;
      sw.setAttribute('aria-checked', on ? 'true' : 'false');
      box.classList.toggle('is-on', on);
    }

    box.hidden = false;
    if (!m || !m.base) {
      if (attivi.length) {
        n.textContent = totale() || '✓';
        t.textContent = 'Filtro moto attivo: ' + attivi.map(function (x) { return x.v; }).join(', ');
        so.textContent = 'Togli il filtro per vedere tutti i risultati.';
        stato(true);
        sw.href = spento();
        filtroMotoAttivo = true;
      } else {
        n.textContent = '?';
        t.textContent = 'Vedi solo gli accessori che montano sulla tua moto';
        so.textContent = 'Sceglila una volta: la ricordiamo su tutto il sito.';
        sw.hidden = true;
        sc.hidden = false;
        box.classList.remove('is-on');
      }
      if (cnt) cnt.hidden = true;
      return;
    }

    var nome = (m.marca ? m.marca + ' ' : '') + m.base;
    var mod = null;
    (d.modelli || []).forEach(function (x) { if (!mod && norm(x.v) === norm(m.base)) mod = x; });
    var vai_moto = $('[data-erd-ric-vai-moto]', box);
    if (vai_moto) vai_moto.remove();
    n.classList.remove('is-icona');
    if (!mod) {
      /* Il filtro Modello di questa ricerca non contiene la moto: niente «0», contiamo le schede ok (universali o con il modello) */
      var nOk = schede().filter(function (c) { return okScheda(c, norm(m.base)); }).length;
      n.classList.toggle('is-icona', nOk === 0);
      n.textContent = nOk ? nOk : '';
      if (nOk) {
        t.textContent = (nOk === 1 ? '1 risultato ok' : nOk + ' risultati ok') + ' per la tua ' + nome;
        so.textContent = 'Li riconosci dal bollino verde «Ok per la tua moto». Tutto il catalogo per la tua moto è nella sua collezione.';
      } else {
        t.textContent = 'Nessun risultato segnato per la tua ' + nome;
        so.textContent = 'Guarda tutti gli accessori per la tua moto, oppure verifica la compatibilità nella scheda.';
      }
      sw.hidden = true;
      sc.hidden = true;
      box.classList.remove('is-on');
      if (m.url && m.url.indexOf('/collections/') === 0) {
        var a = document.createElement('a');
        a.className = 'erd-ric__scegli';
        a.setAttribute('data-erd-ric-vai-moto', '');
        a.href = m.url.split('?')[0];
        a.textContent = 'Accessori per la tua ' + m.base;
        box.appendChild(a);
      }
      if (attivi.length) { stato(true); sw.href = spento(); }
      if (cnt) cnt.hidden = true;
      return;
    }

    /* Il conteggio anticipato di Shopify per i modelli non è affidabile: il numero si mostra solo a filtro attivo, dai risultati reali */
    var tot = totale() || 0;
    t.textContent = 'Solo accessori per la tua ' + nome;
    stato(!!mod.on);
    if (mod.on) {
      n.textContent = tot || '✓';
      so.textContent = 'Compatibilità verificata: nascondiamo quelli che non montano. Cambia moto dalla barra in alto.';
      sw.href = spento();
      filtroMotoAttivo = true;
    } else {
      n.textContent = '?';
      so.textContent = 'Attiva per vedere solo quelli che montano sulla tua moto.';
      var x = new URL(u);
      var marca = null;
      (d.marche || []).forEach(function (v) { if (!marca && norm(v.v) === norm(m.marca)) marca = v.v; });
      if (marca && x.searchParams.getAll(P_MARCA).indexOf(marca) < 0) x.searchParams.append(P_MARCA, marca);
      x.searchParams.append(P_MOD, mod.v);
      sw.href = x.pathname + x.search;
    }
    if (cnt) {
      cnt.textContent = ' · tutti compatibili con la tua ' + m.base;
      cnt.hidden = !mod.on;
    }
  }

  /* Bollino «✓ Ok per la tua moto» sulle schede compatibili */
  function bollini() {
    var m = moto();
    var base = m && m.base ? norm(m.base) : '';
    schede().forEach(function (c) {
      var b = $('.erd-ric__monta', c);
      if (!okScheda(c, base)) { if (b) b.remove(); return; }
      if (b) return;
      var media = $('.product-card__media', c);
      if (!media) return;
      var s = document.createElement('span');
      s.className = 'erd-ric__monta';
      s.textContent = '✓ Ok per la tua moto';
      media.appendChild(s);
    });
  }

  function prog() {
    var p = $('[data-erd-ric-prog]');
    if (!p) return;
    var tot = parseInt(p.getAttribute('data-totale'), 10) || 0;
    var visti = $$('#ProductGridContainer motion-list > .card').length;
    if (tot && visti > tot) visti = tot;
    var v = $('[data-erd-ric-visti]', p);
    if (v) v.textContent = visti;
    var i = $('.erd-ric__bar i', p);
    if (i && tot) i.style.width = Math.min(100, Math.round(visti * 100 / tot)) + '%';
  }

  function aggiorna() { titolo(); compat(); bollini(); prog(); }

  function apriSelettoreMoto() {
    var b = $('[data-erd-sel-btn]') || $('[data-erd-garage-btn]');
    if (!b) return;
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setTimeout(function () { b.click(); }, 250);
  }

  function apriFiltri() {
    var mobile = window.matchMedia('(max-width: 1279px)').matches;
    var b = mobile ? $('facet-sticky .button') : null;
    if (b) { b.click(); return; }
    var side = $('#FacetFiltersContainer');
    if (side) side.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function init() {
    var root = $('.erd-ric');
    if (!root) return;

    root.addEventListener('click', function (e) {
      var a = e.target.closest('[data-erd-ric-ajax], [data-erd-ric-sw]');
      if (a && a.getAttribute('href') && a.getAttribute('href') !== '#') {
        e.preventDefault();
        vai(a.getAttribute('href'));
        return;
      }
      var s = e.target.closest('[data-erd-ric-sort]');
      if (s) {
        e.preventDefault();
        var u = new URL(window.location.href);
        u.searchParams.set('sort_by', s.getAttribute('data-erd-ric-sort'));
        vai(u.toString());
        return;
      }
      if (e.target.closest('[data-erd-ric-scegli]')) { e.preventDefault(); apriSelettoreMoto(); return; }
      if (e.target.closest('[data-erd-ric-filtri]')) { e.preventDefault(); apriFiltri(); }
    });

    /* Dopo ogni cambio di filtri il tema riceve la sezione aggiornata: rinfreschiamo anche la nostra intestazione */
    if (window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS && theme.pubsub.PUB_SUB_EVENTS.facetUpdate) {
      theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.facetUpdate, function (ev) {
        var html = ev && (ev.parsedHTML || (ev.responseText && new DOMParser().parseFromString(ev.responseText, 'text/html')));
        var nuovo = html && html.querySelector('.erd-ric__top');
        var vecchio = $('.erd-ric__top');
        if (nuovo && vecchio) vecchio.innerHTML = nuovo.innerHTML;
        setTimeout(aggiorna, 0);
      });
    }

    /* «Mostra altri»: i prodotti vengono aggiunti alla griglia */
    var grid = $('#ProductGridContainer');
    if (grid && 'MutationObserver' in window) {
      var t = null;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(aggiorna, 60);
      }).observe(grid, { childList: true, subtree: true });
    }

    /* La parola cercata resta scritta nella barra di ricerca in alto (mai «*») */
    var parola = parolaCercata();
    var p = new URLSearchParams(window.location.search);
    if (parola && (p.get('q') || '').trim() === '*' && !p.get('erd_q')) parola = '';
    if (parola) {
      var scrivi = function () {
        $$('.erd-testata input[name="q"]').forEach(function (i) { if (!i.value || i.value === '*') i.value = parola; });
      };
      scrivi();
      setTimeout(scrivi, 300);
    }

    aggiorna();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
